import DashboardContainer from '../containers/DashboardContainer';

export default {
    path: '/',
    component: DashboardContainer,
    exact: true,
    title: 'dashboard',
    description: 'dashboard_detail',
    icon: './icons/dashboard.svg'
};
